const WIDGET_SESSION_STORAGE_KEY = 'chatbot-widget-session'
const CONVERSATION_VERSION_STORAGE_KEY = 'travel-assistant-conversation-version'

/**
 * Increment only when an incompatible chatbot release must start a new conversation.
 */
export const CONVERSATION_VERSION = 2

export function invalidatePersistedSessionOnVersionChange(): void {
  if (typeof window === 'undefined') return

  try {
    const currentVersion = String(CONVERSATION_VERSION)
    const storedVersion = window.localStorage.getItem(CONVERSATION_VERSION_STORAGE_KEY)

    if (storedVersion === currentVersion) return

    window.localStorage.removeItem(WIDGET_SESSION_STORAGE_KEY)
    window.localStorage.setItem(CONVERSATION_VERSION_STORAGE_KEY, currentVersion)
  } catch {
    // Version invalidation is best effort when browser storage is unavailable.
  }
}
